import { DEFAULT_CONTINUOUS_LEGEND_THEME } from "./continuous";

const handlerTheme = {
    style: {
        symbolType: "circle",
        lineWidth: 0,
        outerBorder: {
            lineWidth: 2,
            distance: .8,
            stroke: {
                type: "palette",
                key: "sliderTrackColor"
            }
        },
        fill: {
            type: "palette",
            key: "sliderHandleColor"
        }
    }
};

export const sizeLegend = {
    horizontal: Object.assign(Object.assign({}, DEFAULT_CONTINUOUS_LEGEND_THEME), {
        sizeBackground: {
            fill: {
                type: "palette",
                key: "dataZoomChartColor"
            }
        },
        track: {
            style: {
                fill: {
                    type: "palette",
                    key: "sliderTrackColor",
                    a: .8
                }
            }
        },
        rail: {
            width: 200,
            height: 4,
            style: {
                fill: {
                    type: "palette",
                    key: "sliderRailColor"
                }
            }
        },
        handler: handlerTheme
    }),
    vertical: Object.assign(Object.assign({}, DEFAULT_CONTINUOUS_LEGEND_THEME), {
        sizeBackground: {
            fill: {
                type: "palette",
                key: "dataZoomChartColor"
            }
        },
        track: {
            style: {
                fill: {
                    type: "palette",
                    key: "sliderTrackColor",
                    a: .8
                }
            }
        },
        rail: {
            width: 4,
            height: 200,
            style: {
                fill: {
                    type: "palette",
                    key: "sliderRailColor"
                }
            }
        },
        handler: handlerTheme
    })
};
//# sourceMappingURL=size-legend.js.map
